import { API } from '@/config';
import store from '@/store';
import socket from '@/services/socket.service';
import ExpiredProjectsService from '@/services/ExpiredProjectsService';

export default {
  namespaced: true,
  state: {
    isAuthenticated: false,
    isWaitingForAuthorisation: false,
    user: null,
  },

  getters: {
    isAuthenticated: state => state.isAuthenticated,
    isWaitingForAuthorisation: state => state.isWaitingForAuthorisation,
    user: state => state.user,
    acl: state => ({
      hasAccessForRoles(roles = []) {
        if (state.user) {
          const userRole = state.user.role;
          return roles.some(role => role === userRole);
        }
        return [];
      },
      hasPermission(permission) {
        if (state.user) {
          const userPermisions = state.user.permissions;
          return userPermisions.some(_permission => _permission === permission);
        }
        return [];
      },
    }),
  },

  mutations: {
    SET_AUTHENTICATED(state, payload) {
      const _state = state;
      _state.isAuthenticated = payload;
      _state.isWaitingForAuthorisation = false;
    },
    SET_WAITING_FOR_AUTHORISATION(state, payload) {
      const _state = state;
      _state.isWaitingForAuthorisation = payload;
    },
    SET_USER_DATA(state, payload) {
      const _state = state;
      _state.user = payload;
    },
  },

  actions: {
    async loginToPlatform({ commit }, { endpoint, params }) {
      commit('SET_WAITING_FOR_AUTHORISATION', true);
      try {
        const { url } = (await API.post(endpoint, params)).data.data;
        return url;
      } catch (err) {
        commit('SET_AUTHENTICATED', false);
        commit('SET_WAITING_FOR_AUTHORISATION', false);
        return null;
      }
    },
    async logoutFromPlatform({ commit }, { endpoint }) {
      ExpiredProjectsService.removeProjectsFromLocalStorage();
      commit('SET_WAITING_FOR_AUTHORISATION', true);
      try {
        await API.delete(endpoint);
        commit('SET_AUTHENTICATED', false);
        commit('SET_USER_DATA', null);
        socket.disconnect();
        return;
      } catch (err) {
        commit('SET_AUTHENTICATED', true);
        commit('SET_WAITING_FOR_AUTHORISATION', false);
      }
    },
    async checkIfUserSessionExists({ commit }, { endpoint }) {
      commit('SET_WAITING_FOR_AUTHORISATION', true);
      try {
        const user = (await API.get(endpoint)).data.data;
        if (user && !socket.socket && !socket.isSocketConnected()) {
          socket.connect();
          socket.handleSetSessionConnection(
            user.user_uuid,
            () => {
              store.dispatch('global/toogleServerSocketConnection', true);
            },
          );
        }
        commit('SET_USER_DATA', user);
        commit('SET_AUTHENTICATED', true);
      } catch (err) {
        commit('SET_AUTHENTICATED', false);
        commit('SET_USER_DATA', null);
        commit('SET_WAITING_FOR_AUTHORISATION', false);
      }
    },
    async registerToPlatform({ commit }, { endpoint, params }) {
      commit('SET_WAITING_FOR_AUTHORISATION', true);
      try {
        const { url } = (await API.post(endpoint, params)).data.data;
        return url;
      } catch (err) {
        commit('SET_AUTHENTICATED', false);
        commit('SET_WAITING_FOR_AUTHORISATION', false);
        return null;
      }
    },
  },
};
